<template>
  <credentials-with-async-fallback
      :is-loading="isLoading"
      :async-timeout-reached="asyncTimeoutReached"
      :source-name="updatedCredentialsSourceName"
      :on-timeout="onTimeout"
      :on-success="onSuccess"
      :loading-start-time="loadingStartTime"
      class="content-wrapper">
  </credentials-with-async-fallback>
</template>

<script>
import CredentialsWithAsyncFallback from '@/pages/responsive-pages/authenticated/onboard2/CredentialsWithAsyncFallback';
import { mapState, mapActions, mapGetters } from 'vuex';
import Segment from '@/Segment';
import router from '@/router';
import CredentialsConnectionSuccess
  from '@/pages/responsive-pages/authenticated/onboard2/steps/create-credentials-flow/CredentialsConnectionSuccess';
import { getSourceConfigurationBySourceName } from '@/constants/sourcesConfiguration';
import OBKConnectionSuggestion from '@/pages/responsive-pages/non-authenticated/open-banking/OBKConnectionSuggestion';

export default {
  name: 'LoadingOBKCredentials',
  components: {
    CredentialsWithAsyncFallback,
  },
  async created() {
    await this.fetchLoadingCredentialsState();
    await this.handleLoadingState();
  },
  computed: {
    ...mapState('websocket', ['socketMessage']),
    ...mapState('credentials', ['isLoading', 'updatedCredentialsSourceName', 'loadingStartTime', 'asyncTimeoutReached', 'connectedConsentMetadata']),
    ...mapGetters('credentials', ['getCredsBankCCAccounts', 'validNonOBkCredentials']),
    source() {
      return getSourceConfigurationBySourceName(this.updatedCredentialsSourceName);
    },
    credsMigratedFromPasswords() {
      return !!this.closedBankingCredentialsId;
    },
    closedBankingCredentialsId() {
      return this.connectedConsentMetadata?.closedBankingCredentialsId;
    },
    bankCCAccounts() {
      return this.getCredsBankCCAccounts(this.closedBankingCredentialsId);
    },

  },
  methods: {
    ...mapActions('credentials', ['fetchLoadingCredentialsState', 'handleLoadingState']),
    ...mapActions('modalRootStore', ['openModal', 'closeModal', 'closeAllModals']),
    async onTimeout() {
      Segment.trackUserGot('TimeoutOnAsyncFallbackFromOBK', { sourceName: this.sourceName });
      console.log('timeout');
      await router.push({ path: '/home' });
    },
    async onSuccess() {
      this.openModal({
        component: CredentialsConnectionSuccess,
        props: {
          sourceType: this.source.type,
          sourceName: this.source.sourceName,
          closeAction: this.credsMigratedFromPasswords && this.validNonOBkCredentials?.length ? this.openSuggestOBKConnectionPopup : this.closeModal,
        },
        popupAlignment: 'full-screen',
      });
      Segment.trackUserGot('SuccessOnAsyncFallbackFromOBK', { sourceName: this.sourceName });
      await router.push({ path: '/credentials' });
    },
    openSuggestOBKConnectionPopup() {
      this.openModal({
        component: OBKConnectionSuggestion,
        props: {
          sourceType: this.source.type,
          source: this.source,
          closeAction: this.closeAllModals,
          bankCCAccounts: this.bankCCAccounts,
        },
        popupAlignment: 'full-screen',
      });
    },
  },
  watch: {
    async socketMessage(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.fetchLoadingCredentialsState();
      }
    },
  },
};
</script>
